module.exports = __webpack_public_path__ + "img/logo.3a524c0a.png";